import apiClient from './client';

export interface ApiTokenSummary {
  id: string;
  name: string;
  prefix: string;
  lastUsedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
}

export interface IssuedApiToken extends ApiTokenSummary {
  token: string; // full clear-text, shown once
}

export const apiTokensApi = {
  list: async (): Promise<ApiTokenSummary[]> => {
    const { data } = await apiClient.get<ApiTokenSummary[]>('/api-tokens');
    return data;
  },
  create: async (name: string, expiresAt?: string): Promise<IssuedApiToken> => {
    const { data } = await apiClient.post<IssuedApiToken>('/api-tokens', {
      name,
      ...(expiresAt ? { expiresAt } : {}),
    });
    return data;
  },
  revoke: async (id: string): Promise<void> => {
    await apiClient.delete(`/api-tokens/${id}`);
  },
};

export default apiTokensApi;
